import { CatalogMerchantApi } from '../openapi';
import { config } from './config';

export const MerchantClient = new CatalogMerchantApi(config);
